import { render } from "./404.vue?vue&type=template&id=97500b04"
const script = {}

import "./404.vue?vue&type=style&index=0&id=97500b04&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__